module.exports = __webpack_public_path__ + "views/editMailbox.40a9e74531e2adbfc4e261b87b6b2c4f.html";